"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("_");

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _immutable = require("immutable");

var _classnames = _interopRequireDefault(require("classnames"));

var _enviro = _interopRequireDefault(require("enviro"));

var _generalStore = require("general-store");

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _ProfileOnboardingTourDisplay = _interopRequireDefault(require("crm_ui/components/onboarding/ProfileOnboardingTourDisplay"));

var _OnboardingStore = _interopRequireDefault(require("crm_internal/onboarding/OnboardingStore"));

var _makeUserSettingsDependency = _interopRequireDefault(require("crm_data/settings/makeUserSettingsDependency"));

var _UserSettingsKeys = require("crm_data/settings/UserSettingsKeys");

var _UserSettingsActions = require("crm_data/settings/UserSettingsActions");

var _ProfileObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ProfileObjectTypesType"));

var RECORD_ONBOARDING_KEY = 'recordOnboarding';
var INDEX_TO_STEPS = ['start', 'properties', 'automation', 'timeline', 'integrations', 'end'];

var _startTour = (0, _.debounce)(function () {// since router can be called before setup callback, this gives
  // disatch queue time to finish registering the onboarding on load
  // TODO: Remove once Getting Started onboarding page is complete
  // setTimeout(() => {
  //   OnboardingActions.startTour(RECORD_ONBOARDING_KEY);
  // }, 250);
}, 1000, true);

var deps = {
  userSettings: (0, _makeUserSettingsDependency.default)(_UserSettingsKeys.HAS_COMPLETED_RECORD_ONBOARDING),
  inRecordOnboarding: {
    stores: [_OnboardingStore.default],
    deref: function deref() {
      var record = _OnboardingStore.default.get(RECORD_ONBOARDING_KEY);

      if (!record) {
        return false;
      }

      return record.active;
    }
  },
  recordOnboardingStep: {
    stores: [_OnboardingStore.default],
    deref: function deref() {
      var record = _OnboardingStore.default.get(RECORD_ONBOARDING_KEY);

      if (!record) {
        return null;
      }

      return record.onStep;
    }
  }
};

var _default = function _default(WrappedComponent) {
  var RecordOnboardingHOC = (0, _createReactClass.default)({
    propTypes: {
      objectType: _ProfileObjectTypesType.default.isRequired,
      userSettings: _propTypes.default.instanceOf(_immutable.Map),
      recordOnboardingStep: _propTypes.default.number,
      inRecordOnboarding: _propTypes.default.bool.isRequired
    },
    componentDidMount: function componentDidMount() {
      this.attemptStartOnboarding();
    },
    componentDidUpdate: function componentDidUpdate() {
      this.attemptStartOnboarding();
    },
    attemptStartOnboarding: function attemptStartOnboarding() {
      var _this$props = this.props,
          inRecordOnboarding = _this$props.inRecordOnboarding,
          objectType = _this$props.objectType,
          userSettings = _this$props.userSettings;
      var isEligibleType = [_ObjectTypes.CONTACT, _ObjectTypes.COMPANY, _ObjectTypes.DEAL].indexOf(objectType) !== -1;
      var onboardingFlag = userSettings && userSettings.get(_UserSettingsKeys.HAS_COMPLETED_RECORD_ONBOARDING);
      var hasntFinishedOnboarding = onboardingFlag === null && typeof onboardingFlag !== 'undefined';

      var debugMode = _enviro.default.debug(RECORD_ONBOARDING_KEY);

      var isEligible = hasntFinishedOnboarding && isEligibleType;

      if (!inRecordOnboarding && (debugMode || isEligible)) {
        _startTour();
      }
    },
    getRecordOnboardingStepName: function getRecordOnboardingStepName() {
      var recordOnboardingStep = this.props.recordOnboardingStep;
      return INDEX_TO_STEPS[recordOnboardingStep];
    },
    getRecordOnboardingClassName: function getRecordOnboardingClassName() {
      var stepName = this.getRecordOnboardingStepName();
      return (0, _classnames.default)('profile-onboarding-tour', {
        'highlight-sidebar': stepName === 'properties',
        'highlight-timeline': stepName === 'timeline',
        'highlight-communicator': stepName === 'end'
      });
    },
    handleExit: function handleExit() {
      _enviro.default.setDebug(RECORD_ONBOARDING_KEY, false);

      (0, _UserSettingsActions.saveUserSetting)(_UserSettingsKeys.HAS_COMPLETED_RECORD_ONBOARDING, true);
    },
    renderProfileOnboarding: function renderProfileOnboarding() {
      var _this$props2 = this.props,
          objectType = _this$props2.objectType,
          recordOnboardingStep = _this$props2.recordOnboardingStep,
          inRecordOnboarding = _this$props2.inRecordOnboarding;

      if (!inRecordOnboarding) {
        return null;
      }

      return [_react.default.createElement("div", {
        className: "onboarding-overlay",
        key: "onboarding-overlay"
      }), _react.default.createElement("div", {
        className: "onboarding-overlay-transparent",
        key: "overlay-transparent"
      }), _react.default.createElement(_ProfileOnboardingTourDisplay.default, {
        key: "ProfileOnboardingTourDisplay",
        objectType: objectType,
        onClose: this.handleExit,
        onEnd: this.handleExit,
        stepIndex: recordOnboardingStep,
        stepName: this.getRecordOnboardingStepName()
      })];
    },
    render: function render() {
      return _react.default.createElement("div", {
        className: this.getRecordOnboardingClassName()
      }, _react.default.createElement(WrappedComponent, this.props), this.renderProfileOnboarding());
    }
  });
  return (0, _generalStore.connect)(deps)(RecordOnboardingHOC);
};

exports.default = _default;
module.exports = exports.default;